import { GetterTree } from 'vuex'
import { ContactsState } from './contacts.types'

export const getters: GetterTree<ContactsState, unknown> = {
  contacts: state => {
    return state.contacts
  },

  emailsInCurrentFolder:
    state =>
    (ids: Array<string> = []) => {
      return ids.flatMap(id => state.contacts.filter(c => c._id === id)).map(c => c.email)
    },

  contactEmails: state => {
    return state.contacts.map(c => c.email)
  }
}
